export const OET_SPECIAL_CATEGORIES = [
  "Interlocutor Fee",
  "Interlocutor Conveyance",
  "Helper Charges",
  "Support Staff",
  "Invigilator Fee",
  "Catering Charges",
];

export const OET_CASH_VOUCHER_APPROVAL_LIMITS = {
  "Helper Charges": 1750,
};

export const PERSON_DETAIL_CATEGORIES = new Set([
  "Interlocutor Fee",
  "Interlocutor Conveyance",
  "Helper Charges",
  "Support Staff",
  "Invigilator Fee",
]);

export function isOetTrip({ company, tripTitle }) {
  return company === "ebek" && /\boet\b/i.test(tripTitle || "");
}

export function isOetSpecialCategory(category) {
  return OET_SPECIAL_CATEGORIES.includes(category);
}

export function getExpenseCategoriesForTrip(baseCategories, { company, tripTitle }) {
  if (!isOetTrip({ company, tripTitle })) return baseCategories;
  return [...baseCategories, ...OET_SPECIAL_CATEGORIES];
}

export function getBillTypeForCategory(currentBillType, category) {
  return (isOetSpecialCategory(category) && category !== "Catering Charges") || category === "Tips"
    ? "cash_voucher"
    : currentBillType;
}

export function getOetCashVoucherApprovalLimit(category) {
  return OET_CASH_VOUCHER_APPROVAL_LIMITS[category] || null;
}
